import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { WelcomeScreen } from './components/WelcomeScreen';
import { ModuleView } from './components/ModuleView';
import { SignatureScreen } from './components/SignatureScreen';
import { CompletionScreen } from './components/CompletionScreen';
import { PrintLayout } from './components/PrintLayout';
import { module1Data } from './data/module1';
type AppState = 'welcome' | 'module' | 'signature' | 'completion';
export function App() {
  const [appState, setAppState] = useState<AppState>('welcome');
  const [user, setUser] = useState({
    firstName: '',
    lastName: ''
  });
  const [signatureDataUrl, setSignatureDataUrl] = useState<string>('');
  const handleStart = (firstName: string, lastName: string) => {
    setUser({
      firstName,
      lastName
    });
    setAppState('module');
  };
  const handleModuleComplete = () => {
    setAppState('signature');
  };
  const handleSignatureComplete = (dataUrl: string) => {
    setSignatureDataUrl(dataUrl);
    setAppState('completion');
  };
  const handleReset = () => {
    setUser({
      firstName: '',
      lastName: ''
    });
    setSignatureDataUrl('');
    setAppState('welcome');
  };
  return <>
      {/* Interactive UI (Hidden during print) */}
      <div className="print:hidden" data-id="element-0">
        <AnimatePresence mode="wait" data-id="element-1">
          {appState === 'welcome' && <WelcomeScreen key="welcome" onStart={handleStart} data-id="element-2" />}

          {appState === 'module' && <ModuleView key="module" moduleData={module1Data} onComplete={handleModuleComplete} data-id="element-3" />}

          {appState === 'signature' && <SignatureScreen key="signature" firstName={user.firstName} lastName={user.lastName} onComplete={handleSignatureComplete} data-id="element-4" />}

          {appState === 'completion' && <CompletionScreen key="completion" firstName={user.firstName} onReset={handleReset} data-id="element-5" />}
        </AnimatePresence>
      </div>

      {/* Print Layout (Only visible during window.print()) */}
      {appState === 'completion' && <PrintLayout moduleData={module1Data} firstName={user.firstName} lastName={user.lastName} signatureDataUrl={signatureDataUrl} data-id="element-6" />}
    </>;
}